import request from '@/utils/request2'

// 列表(主数据列表)
export function loadTerminalVisitConfigActionListDataApi(data) {
  return request({
    url: 'tms-web/terminalVisitConfigAction/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportTerminalVisitConfigActionListDataApi(data) {
  return request({
    url: 'tms-web/terminalVisitConfigAction/exportByPage',
    method: 'post',
    data
  })
}

// 保存
export function saveTerminalVisitConfigActionApi(data) {
  return request({
    url: 'tms-web/terminalVisitConfigAction/save',
    method: 'post',
    data
  })
}

// 变更状态
export function updateStatusTerminalVisitConfigActionApi(data) {
  return request({
    url: 'tms-web/terminalVisitConfigAction/updateStatus',
    method: 'post',
    data
  })
}

// 作废
export function deleteTerminalVisitConfigActionApi(data) {
  return request({
    url: 'tms-web/terminalVisitConfigAction/delete',
    method: 'post',
    data
  })
}

// 查看
export function viewTerminalVisitConfigActionApi(data) {
  return request({
    url: 'tms-web/terminalVisitConfigAction/view',
    method: 'post',
    data
  })
}

// 列表
export function listTerminalVisitConfigActionApi(data) {
  return request({
    url: 'tms-web/terminalVisitConfigAction/list',
    method: 'post',
    data
  })
}
